// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'
import queryString from 'query-string'
import { history } from '../../_redux/_store/history'
import { BreadcrumbDispatch } from '../../App';
import { makeStyles } from '@material-ui/core/styles'
import {useDispatch, useSelector } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import {Select, MenuItem,TextField,Button,Dialog,DialogContent,Typography,Table,TableBody,TableCell,TableContainer, TableHead, TableRow } from '@material-ui/core/'
import {fetchFindingField, createNewFindingRule, fetchSelectFindingRule} from '../../_redux/_actions/selectFindingRuleAction'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import ErrorHandler from '../updateHandlers/ErrorHandler'
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

const useStyles = makeStyles(() => ({
    heading:{
        lineHeight: '130%',
        fontWeight: 700,
        fontSize: '20px',
        color: '#262523',
        margin: '10px 0px'
    },
    subheading:{
        margin:'10px 0px',
        fontWeight: 700,
        fontSize: '14px',
        lineHeight: '150%',
        color: '#262523'
    },
    findingFieldSelect: {
        width: '120px',
        height: '50px',
        marginLeft: '10px',
    },
    input:{
        margin:'20px 0px',
        width: '90%'
    },
    Button: {
        width: '120px',
        margin: '20px 0px 0px 20px',
        borderRadius: '3px !important',
        '&:hover': {
          background: '#52A1C2',
        },
    },
    similarFindingSection:{
        border: '1px solid #BFB8AF',
        borderRadius: '5px'
    },
    tableContainer:{
        maxHeight: 'calc(80vh - 100px)',
        overflowY:'scroll'
    },
    tableHead:{
        width:'50%',
        fontWeight:700,
        lineHeight:'150%',
        padding:'10px 0px',
        background: '#F5F3F1'
    },
    tableHeading:{
        fontSize: '14px !important',
        fontWeight: '700 !important',
        color: 'rgb(38, 37, 35)'
    }
}))

export default function CreateFindingRule (){
    const classes = useStyles()
    const dispatch = useDispatch()
    const findingNameRef = useRef()
    const findingDescriptionRef = useRef()
    const queryValues = queryString.parse(history.location.search)
    const {machine_type, hmi_type} = queryValues
    const [newRule, setNewRule] = useState('')
    const [findingField, setFindingField] = useState([])
    const [findingFieldAdded, setFindingFieldAdded] = useState('none')
    const [newRuleDescription, setNewRuleDescription] = useState('')
    const [newFindingId, setNewFindingId] = useState('')
    const [createRuleSuccess, setCreateRuleSuccess] = useState(false)
    const [createRuleError, setCreateRuleError] = useState(false)
    const [similarFindings, setSimilarFindings] = useState([])
    const [allFindings, setAllFindings] = useState([])
    const [disable, setDisable] = useState(false)

    const selectFindingRuleResponse = useSelector(
        (state) => state.selectFindingRule
    )

    // eslint-disable-next-line
    useEffect(()=>{
        dispatch(fetchFindingField(machine_type,hmi_type))
        dispatch(fetchSelectFindingRule(null, machine_type, hmi_type))
        setAllFindings(selectFindingRuleResponse)
    },[])

    useEffect(() => {
        if (selectFindingRuleResponse.selectFindingField) {
        setFindingField(selectFindingRuleResponse.selectFindingField)
        setFindingFieldAdded(selectFindingRuleResponse.selectFindingField[0] ? selectFindingRuleResponse.selectFindingField[0].id : null)
        }
        if(selectFindingRuleResponse.selectFindingRule){
            if(newRule || newRuleDescription){
                setNewRule(selectFindingRuleResponse.selectFindingRule[0].name)
                setNewRuleDescription(selectFindingRuleResponse.selectFindingRule[0].description)
                setFindingFieldAdded(selectFindingRuleResponse.selectFindingRule[0].findingField ? 
                    findingField.find(item => item.name === selectFindingRuleResponse.selectFindingRule[0].findingField.name).id : ''
                )
            }
        }
    }, [selectFindingRuleResponse])

    useEffect(() =>{
        filterFindings()
        if(selectFindingRuleResponse.selectFindingRule[0]){
            if(newRule.trim() !== (selectFindingRuleResponse.selectFindingRule[0] && selectFindingRuleResponse.selectFindingRule[0].name.trim()) ||
                newRuleDescription.trim() !== selectFindingRuleResponse.selectFindingRule[0].description.trim() 
                // ||
                // findingFieldAdded !== (findingField.find(item => 
                //     item.name === selectFindingRuleResponse.selectFindingRule[0].findingField.name 
                // ).id)
            )
            {setDisable(false) } 
            else
            {setDisable(true)}
        }
    }, [newRule,newRuleDescription, findingFieldAdded])

    //select finding field
    const handleFindingFieldChange = (event) => {
        setFindingFieldAdded(event.target.value)
    }

    //Creating New Rule
    const updateNewRule = () => {
        if(newRule || newRuleDescription){
            const body = {
            name: newRule.trim(),
            description: newRuleDescription.trim(),
            finding_field_id: findingFieldAdded,
            }
            dispatch(createNewFindingRule(body, handleCreateFindingRule, machine_type,hmi_type))
        }
    }

    const handleCreateFindingRule = (data) => {
        if (data) {
          setNewFindingId(data.finding_rule_id)
          setCreateRuleSuccess(true)
        } else {
          //setFindingFieldAdded
          setCreateRuleError(true)
        }
    }

    //close create new rule success intimation pop up
    const closeSuccess = () => {
        setCreateRuleSuccess(false)
        history.push(`/rules/select_finding_rule/select_scope?machine_type=${machine_type}&hmi_type=${hmi_type}&findingRuleId=${newFindingId}`)
    }

    //filtering similar finding rules
    const filterFindings = () =>{
        let keyword = []
        let ruleKey = newRule ? newRule.split(" ") : ""
        let descriptionKey = newRuleDescription ? newRuleDescription.split(" ") : ""
        let keywordSet = new Set([...ruleKey, ...descriptionKey]);
        keyword = Array.from(keywordSet);
        let filteredFindings = []
        let searchMatch = []
        allFindings.selectFindingRule && allFindings.selectFindingRule.map((item)=>{
            keyword && keyword.map((key)=>{
                if(key !== " " &&  key.length > 1){
                    if(item.name.toLowerCase().includes(key) || item.description.toLowerCase().includes(key)){
                        if(searchMatch && !searchMatch.find(match => match.id === item.id)){
                            searchMatch.push(item)
                        }
                    }
                }
            })
        })
        filteredFindings = searchMatch 
        setSimilarFindings(() => {
            return [...filteredFindings];
        });
    }

    const searchRule = (value) =>{
        setNewRule(value)
    }

    const searchDescription = (value) =>{
        setNewRuleDescription(value)
    }

    const clearInputField = () =>{
        findingDescriptionRef.current.value = ""
        findingNameRef.current.value = ""
        setNewRule("")
        setNewRuleDescription("")
    }

    const updateSelectedSimilarFinding = async (similarFinding) =>{
        setDisable(true)       
        await dispatch(fetchSelectFindingRule(similarFinding.id, machine_type, hmi_type))
    }

    return(
        <>
        <Grid container spacing={2} style={{padding:'50px'}}>
            <BreadcrumbDispatch />
            <Grid item xs={7}>
             <div className={classes.heading}>Create Finding Rule</div>
             <div className={classes.subheading}>Workspace can be used to create a new finding rule or select from existing finding rules</div>
             <TextField
                inputRef={findingNameRef}
                className={classes.input}
                value={newRule}
                id='new_anomalyrule'
                label='Finding Rule Name'
                placeholder='Input Text'
                variant='outlined'
                fullWidth
                onChange={(e) => searchRule(e.target.value)}
              />
             <div>
                Finding Field :
                <Select
                    className={classes.findingFieldSelect}
                    id='finding_field_select'
                    variant='outlined'
                    MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                    }}
                    value={findingFieldAdded ? findingFieldAdded : null}
                    onChange={handleFindingFieldChange}
                >
                    {findingField &&
                        findingField.map((item) => (
                        <MenuItem
                            key={`${item.name}${item.id}`}
                            id={item.id}
                            value={item.id}
                        >
                            {item.name}
                        </MenuItem>
                    ))}
                </Select>
              </div>
              <TextField
                inputRef={findingDescriptionRef}
                className={classes.input}
                value={newRuleDescription}
                multiline
                rows={10}
                placeholder='Description of Finding Rule'
                id='finding rule description'
                variant='outlined'
                fullWidth
                onChange={(e) => searchDescription(e.target.value)}
              ></TextField>
              <Grid container direction='row' style={{ marginBottom: '3em', justifyContent:'right', width:'90%' }}>
                <Grid item>
                    <Button
                    variant='outlined'
                    className={classes.Button}
                    onClick={clearInputField}
                    >
                    Cancel
                    </Button>
                    {disable && 
                        <Button
                        variant='outlined'
                        className={classes.Button}
                        onClick={()=>history.push(`/rules/select_finding_rule/select_scope?machine_type=${machine_type}&hmi_type=${hmi_type}&findingRuleId=${selectFindingRuleResponse.selectFindingRule[0].id}`)}
                        >
                        Next 
                        </Button>
                    }
                    <Button
                    variant='outlined'
                    disabled={!newRule || !newRuleDescription || !findingField || disable}
                    className={classes.Button}
                      onClick={() => {
                        updateNewRule()
                      }}
                    >
                    Done
                    </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={5} className={classes.similarFindingSection}>
                <div style={{height:'26px'}}></div>
                <div className={classes.subheading}>Similar Finding Rules</div>
                <div>
                    <TableContainer id="similar_findings_table" className={classes.tableContainer}>
                        <Table aria-label='custom pagination table'>
                            <TableHead>
                                <TableRow>
                                <TableCell className={classes.tableHead}>
                                    <Typography className={classes.tableHeading}>Finding Rule Name</Typography>
                                </TableCell>
                                <TableCell align='left' className={classes.tableHead}>
                                    <Typography className={classes.tableHeading}>Description</Typography>
                                </TableCell>
                                <TableCell className={classes.tableHead}></TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                        <TableBody id="similar_findings" fullwidth='true'>
                            {similarFindings && similarFindings.map(item=>
                            (
                                <TableRow>
                                    <TableCell style={{width:'50%'}}>{item.name}</TableCell>
                                    <TableCell style={{width:'50%'}}>{item.description}</TableCell>
                                    <TableCell 
                                        style={{cursor:'pointer'}} 
                                        onClick={()=> updateSelectedSimilarFinding(item)}                                   
                                    >
                                        <KeyboardArrowRightIcon/>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </TableContainer>
                </div>
            </Grid>

            {/*create finding rule error */}
            {createRuleError && (
            <ErrorHandler message={selectFindingRuleResponse.error} />
            )}

            {/* Pop up to show if create new rule has been successful */}
            <Dialog
                open={createRuleSuccess}
                onClose={() => setCreateRuleSuccess(false)}
                maxWidth={'md'}
                PaperProps={{ style: { width: '30em', height: '20em' } }}
            >
                <DialogContent style={{ padding: '30px' }}>
                <Grid
                    item
                    container
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                >
                    <Grid item>
                    <CheckCircleOutlineIcon
                        style={{ width: '3em', height: '3em', color: '#52A1C2' }}
                    />
                    </Grid>
                    <Grid item style={{ marginTop: '20px', marginBottom: '20px' }}>
                        New Finding Rule has been created successfully
                    </Grid>
                    <Grid item>
                    <Button
                        onClick={() => closeSuccess()}
                        className={classes.Button}
                        variant='outlined'
                    >
                        <Typography>OK</Typography>
                    </Button>
                    </Grid>
                </Grid>
                </DialogContent>
            </Dialog>
        </Grid>
        </>
    )
}